<ncp-table #problemsDiagnoses [(options)]="options"></ncp-table>
